import { useSelector } from "react-redux";
import clsx from "clsx";
import Shops from "../../components/main/shops";
import styles from "./index.module.scss";
import Breadcrumbs from "../../components/common/breadcrumbs";
import { wrapper } from "/redux";
import { addBreadcrumb } from "/redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import pagesWrapper from "../../utils/pagesWrapper";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import Map from "../../components/main/map";
import OldMap from "../../components/common/oldMap";

export default function ContactsPage({ scripts, host, isBaltex, isFarkop }) {
  const { content } = useSelector((state) => state.meta);
  const { cityName } = useSelector((state) => state.location);
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <div className="container">
        <Breadcrumbs />
        <div className={clsx(isBaltex && styles.Baltex)}>
          <h1>Контакты</h1>
          {host === "msk.farkop.ru" ||
          host === "spb.farkop.ru" ||
          host === "localhost:3000" ? (
            <Map isShowTitle={false} />
          ) : (
            <OldMap isBaltex={isBaltex} />
          )}
          {isFarkop && (
            <div>
              {cityName !== "Россия" && (
                <>
                  <h2>Все магазины и установочные центры</h2>
                  {host === "msk.farkop.ru" ||
                  host === "spb.farkop.ru" ||
                  host === "localhost:3000" ? (
                    <Shops
                      rows={3}
                      host={host}
                      isBaltex={false}
                      isShowShopsForRegions={false}
                    />
                  ) : (
                    <div>
                      Мы работаем над открытием сервисного центра в г.
                      {cityName}, можем предложить отправку товара в Ваш город
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          <div className={styles.Requisite}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ req, query }) => {
    store.dispatch(addBreadcrumb({ link: "/contacts/", name: "Контакты" }));

    return pagesWrapper(
      {},
      store,
      Redis,
      {
        query,
        req,
      },
      "/contacts/",
    );
  };
});
